import { render, staticRenderFns } from "./LxAdminPanel.vue?vue&type=template&id=5f5256bc&scoped=true"
import script from "./LxAdminPanel.vue?vue&type=script&lang=js"
export * from "./LxAdminPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5256bc",
  null
  
)

export default component.exports